import {createAction, props} from '@ngrx/store';
import {ChangeDetectionItem} from '@iw-shared/store/state/change-detection.state';

export const setChangedItem = createAction('[Change detection] set item', props<{ item: ChangeDetectionItem }>());
export const resetChangedItems = createAction('[Change detection] reset items');

